import { Briefcase, User } from 'lucide-react';
import type { ComponentType } from 'react';
import { NavLink } from 'react-router-dom';

import Logo from '@/components/common/Logo';
import cn from '@/utils/cn';
import { ROUTES } from '@/utils/constants';

interface NavItem {
  title: string;
  url: string;
  icon: ComponentType<{ className?: string }>;
  end?: boolean;
}

const NAV: NavItem[] = [
  {
    title: 'Work Queue',
    url: ROUTES.SERVICE,
    icon: Briefcase,
    end: true,
  },
  { title: 'Profile', url: ROUTES.SERVICE_PROFILE, icon: User },
];

interface ServiceSidebarProps {
  collapsed: boolean;
}

export const ServiceSidebar = ({ collapsed }: ServiceSidebarProps) => (
  <aside
    className={cn(
      'flex shrink-0 flex-col border-r border-sidebar-border bg-sidebar transition-[width] duration-200',
      collapsed ? 'w-16' : 'w-60',
    )}
  >
    <div className="flex h-14 items-center border-b border-sidebar-border px-3">
      <Logo to={ROUTES.SERVICE} showWordmark={!collapsed} />
    </div>

    <nav className="flex-1 overflow-y-auto p-2">
      {!collapsed && (
        <p className="px-2 py-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          Service
        </p>
      )}
      <ul className="space-y-1">
        {NAV.map((item) => (
          <li key={item.title}>
            <NavLink
              to={item.url}
              end={item.end}
              title={item.title}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm font-semibold transition-colors',
                  collapsed && 'justify-center',
                  isActive
                    ? 'bg-sidebar-accent text-sidebar-accent-foreground'
                    : 'text-sidebar-foreground/70 hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
                )
              }
            >
              <item.icon className="h-4 w-4 shrink-0" />
              {!collapsed && <span>{item.title}</span>}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>

    {!collapsed && (
      <div className="border-t border-sidebar-border px-3 py-2 text-[10px] text-muted-foreground">
        v0.1.0 · DEV
      </div>
    )}
  </aside>
);
